import * as Sentry from '@sentry/react';
import { ErrorEvent } from '@sentry/types';
import { Env } from '../Env.ts';
import debug from 'debug';
import {
    BrowserOptions,
    EventHint,
    setExtra,
    setTag,
    setUser,
} from '@sentry/react';
import { AccessTokenPayload } from '../Types/Varios.ts';

const log = debug('sentry');

export function InitSentry() {
    const options: BrowserOptions = {
        //esto es para apagar sentry en dev
        // dsn: Env.MODE === 'production' ? Env.SENTRY_DSN : undefined,
        dsn: Env.SENTRY_DSN,
        release: Env.PACKAGE_VERSION,
        environment: import.meta.env.MODE,
        integrations: [
            // Esto agrega un header "baggage" para hacer un seguimiento, pero mi back no lo soporta. Hasta que lo haga, lo saco
            // new Sentry.BrowserTracing({
            //     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            //     tracePropagationTargets: [
            //         'localhost',
            //         'https://local.luker.io',
            //         'https://app.luker.io',
            //         'https://console.luker.io',
            //         'https://auth.luker.io',
            //     ],
            // }),
            new Sentry.Replay({
                networkDetailAllowUrls: [import.meta.env.VITE_GATEWAY_URL],
            }),
        ],
        /**
         * Esto es para poder ver los roles del usuario en el reporte del error
         */
        normalizeDepth: 10,
        // Performance Monitoring
        tracesSampleRate: 0, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        beforeSend(
            event: ErrorEvent,
            hint: EventHint
        ) /*: PromiseLike<Event | null> | Event | null*/ {
            log('Enviando error a sentry:');
            log('beforeSend.event %O', event);
            log('beforeSend.hint %O', hint);
            // eslint-disable-next-line no-console
            console.log(`Error reportado:${event.event_id}`);
            return event;
        },
    };
    log('sentry options: %O', options);
    Sentry.init(options);
}

export function configureSentryInfo(
    userId: string,
    payload: AccessTokenPayload
) {
    //Los tags son buscables
    setTag('superAdmin', payload.is_sadmin);
    setTag('legacy_id', payload.legacy_id);
    const roles = 'roles' in payload ? payload.roles : [];

    //Extra no es buscable, pero se ve en el issue puntual
    setExtra('payload', {
        id: payload.is_sadmin,
        legacy_id: payload.legacy_id,
        roles: roles,
    });
    for (const rol of roles) {
        setTag('rol' + rol.cuenta_id, rol.rol);
    }

    setUser({
        id: userId,
    });
}
